module.exports = __webpack_public_path__ + "GL.png?0581b2c62e1c6c84dbeefe9077ab54fe";